import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react'; 
import '../css/Managehssestyle.css'
import '../css/customBootstrapExtended.css'
class VehicleGroupBox extends React.Component {
    constructor(props) {
        super(props);

        

    }
    render() {
        return ( 

                      <Card>
                          <Card.Title className="card-header">
                          {this.props.Title}
                          <a className="heading-elements-toggle">
                                    <i className="fa fa-ellipsis-v font-medium-3" />
                                  </a>
                                  <div className="heading-elements">
                                    <ul className="list-inline mb-0">
                                      <li>
                                        <a data-action="close">
                                          <FeatherIcon className="feather icon-x" icon="icon-x"/>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                          </Card.Title>
                         
                      </Card>
                               
            );

        }
        
}
        
        
export default VehicleGroupBox;